<template>
    <span v-if="getMenuAuth == constants.AUTH_TYPE.EDIT">
<!--        <button ref="tooltip" type="button" class="buttons-icon tooltipstered" data-type="ghost" data-icon="more" data-size="s" :data-tooltip-content="`#tooltip-${type}`" data-trigger="management">{{$t('LABEL.MANAGE')}}</button>-->

<!--        <div class="tooltip_templates">-->
<!--            <div :id="`tooltip-${type}`">-->
<!--                <ul class="list-actions">-->
<!--&lt;!&ndash;                    <li>&ndash;&gt;-->
<!--&lt;!&ndash;                        <button type="button" class="btn" data-trigger="">{{ $t('DASHBOARD.SUMMARY.BUTTON.CSV_DOWNLOAD')}}&lt;!&ndash;CSV 다운로드&ndash;&gt;</button>&ndash;&gt;-->
<!--&lt;!&ndash;                    </li>&ndash;&gt;-->
<!--                    <li>-->
<!--                        <button type="button" class="btn" data-trigger="" v-on:click="openDashboardReportPopup()">{{ $t('COMMON.REPORT.BUTTON.EXPORT_REPORT')}}&lt;!&ndash;리포트 보내기&ndash;&gt;</button>-->
<!--                    </li>-->
<!--                </ul>-->
<!--            </div>-->
<!--        </div>-->
    </span>
    <!--<li><button type="button" name="button" class="general" >{{ $t('DASHBOARD.SUMMARY.BUTTON.SUBSCRIBE')}}구독하기</button></li>-->
    <!--<li><button type="button" name="button" class="general" >{{ $t('DASHBOARD.SUMMARY.BUTTON.SHARE')}}공유하기</button></li>-->
</template>

<script>
    import PopSendReport from './../common/popSendReport.vue';

    export default {
        name: 'DashboardWidget',
        props:{
            type: String // Widget Type
        },
        components: {
            PopSendReport
        },
        data: function() {
            return {

            }
        },
        mounted: function() {
            this.initWidget()
        },
        computed: {
            getMenuAuth: function(){
                //메뉴 별 권한
                let auth = _.find(this.$store.state.GOV_MENU_AUTH, {menuId: this.constants.MENU.DASHBOARD})
                return auth ? auth.authTypeCd : this.constants.AUTH_TYPE.NONE
            }
        },
        methods: {
            openDashboardReportPopup(){
                console.log('Open Dashboard Report Popup')
                this.Common.viewPopup('popup-send-report-email');
            },
            initWidget(){
                $(this.$refs.tooltip).tooltipster({
                    animation: 'fade',
                    side: 'bottom',
                    theme: 'go-actions',
                    interactive: true,
                    trigger: 'click',
                    arrow: false,
                    functionBefore: function(instance, helper) {
                        $(helper.origin).addClass("selected");
                    },
                    functionAfter: function(instance, helper) {
                        $(helper.origin).removeClass("selected");
                    },
                    functionPosition: function(instance, helper, position) {
                        position.coord.top -= 7;
                        position.coord.left = helper.geo.origin.offset.right - position.size.width;
                        return position;
                    }
                });
            }
        }


    }
</script>




// WEBPACK FOOTER //
// src/components/dashboard/dashboardWidget.vue